import { numberMoney } from 'Data/format.js'
import { LEDGER_ENTRY_TYPE } from 'Data/payments.js'

export function getAmount(transaction) {
  switch (transaction.type) {
    case LEDGER_ENTRY_TYPE.CHARGE:
      return numberMoney(
        transaction.entries.reduce((acc, e) => acc + e.amount, 0)
      )
    case LEDGER_ENTRY_TYPE.ADJUSTMENT:
      return numberMoney(
        Math.abs(transaction.entries.reduce((acc, e) => acc + e.amount, 0))
      )
    case LEDGER_ENTRY_TYPE.TRANSFER_DEBT:
    case LEDGER_ENTRY_TYPE.APPLIED_PAYMENT:
    case LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN:
    case LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK:
    case LEDGER_ENTRY_TYPE.PAYMENT:
      return numberMoney(Math.abs(transaction.amount))
    case LEDGER_ENTRY_TYPE.NOTE:
    default:
      return '-'
  }
}
